var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-tabs',[_c('v-tab',{attrs:{"to":{name: this.$ROUTER_NAMES.USER_DETAILS_EXAMS}}},[_vm._v("Training Exams")]),_c('v-tab',{attrs:{"to":{name: this.$ROUTER_NAMES.USER_DETAILS_EXAMS_CBR}}},[_vm._v("CBR Exams")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }